<template>
    <b-container v-if="this.app === null">
        <b-row class="vh-100 text-center" align-v="center">
            <b-col>
                <b-spinner variant="light" />
            </b-col>
        </b-row>
    </b-container>
    
    <TemplateEditor :nodes="nodes" @save="save" :saving="saving" v-else />
</template>


<script>
import TemplateEditor from '../../components/editor/TemplateEditor'

export default {
    name: 'EditorV2',
    components: {
        TemplateEditor
    },
    data: function() {
        return {
            app: null,
            data: null,
            saving: false,
            
        }
    },
    computed: {
        settings: {
            get() {
                return this.app.settings.find(s => {
                    return s.version == this.$route.query.v
                })
            },

            set(val) {
                // let f = this.app.settings.find(s => {
                //     return s.version == this.$route.query.v
                // })

                // f =

                console.log("set settings", val)
            }
        }
    },
    methods: {
        save: _.debounce(function(data) {
            this.saving = true;

            try {
                let nodes = JSON.parse(data.children[0].toString()).children
            } catch (err) {
                console.log(err)
            } 

            this.$http.post("/v1/system/app/" + this.app.uuid + "/template", { ...this.settings, app_version: 2, workspaces: this.app.workspaces, label: this.app.label }).then(resp => {
                this.saving = false
                if (typeof cb == 'function') {
                    cb()
                }
            }).catch(err => {
                this.$debugLog(err)
                this.$bvModal.msgBoxOk("Failed to save the component.")

                this.saving = false
            })
        }, 500),
    },

    async mounted() {
        try {
            let app = await this.$http.get("/v1/system/app/" + this.$route.params.id)

            if (app.data.owner) {
                this.$bvModal.msgBoxOk("This app is managed by external source.")
                return
            }

            this.app = _.cloneDeep(app.data)

            this.nodes = [
                {
                    name: this.app.name,
                    id: 1,
                    pid: 0,
                    root: true,
                    dragDisabled: false,
                    editNodeDisabled: true,
                    delNodeDisabled: true,
                    addTreeNodeDisabled: false,
                    addLeafNodeDisabled: false,
                    children: this.settings.nodes || []
                }
            ]

            let index = undefined;
            if (this.settings.nodes) {
                // check does templates have index.vue file if not add it programatically
                index = this.settings.nodes.find(n => {
                    return n.name.toLowerCase() == "index.vue" && n.ext == "vue"
                })
            }

            let routes = undefined;
            if (this.settings.nodes) {
                // check does templates have index.vue file if not add it programatically
                routes = this.settings.nodes.find(n => {
                    return n.name.toLowerCase() == "routes.js" && n.ext == "js"
                })
            }

            let config = undefined;
            if (this.settings.nodes) {
                // check does templates have index.vue file if not add it programatically
                config = this.settings.nodes.find(n => {
                    return n.name.toLowerCase() == "config.js" && n.ext == "js"
                })
            }

            if (!index) {
                let indexNode = {
                    name: 'index.vue',
                    id: 3,
                    pid: 1,
                    isLeaf: true,
                    dragDisabled: false,
                    addTreeNodeDisabled: false,
                    addLeafNodeDisabled: false,
                    delNodeDisabled: true,
                    editNodeDisabled: true,
                    ext: 'vue',
                    path: 'index.vue',
                    children: null,
                    editorOptions: {
                        mode: 'text/x-vue'
                    }
                }

                console.log(this.nodes)

                this.nodes[0].children.push(indexNode)
            }

            if (!routes) {
                let routesNode = {
                    name: 'routes.js',
                    id: 4,
                    pid: 1,
                    isLeaf: true,
                    dragDisabled: false,
                    addTreeNodeDisabled: false,
                    addLeafNodeDisabled: false,
                    delNodeDisabled: true,
                    editNodeDisabled: true,
                    ext: 'js',
                    children: null,
                    path: 'routes.js',
                    editorOptions: {
                        mode: 'application/javascript'
                    }
                }

                this.nodes[0].children.push(routesNode)
            }

            if (!config) {
                let configNode = {
                    name: 'config.js',
                    id: 5,
                    pid: 1,
                    isLeaf: true,
                    dragDisabled: false,
                    addTreeNodeDisabled: false,
                    addLeafNodeDisabled: false,
                    delNodeDisabled: true,
                    editNodeDisabled: true,
                    content: `
export default {
    env: {
        live: {},
        dev: {}
    }
}
`,
                    ext: 'js',
                    children: null,
                    path: 'config.js',
                    editorOptions: {
                        mode: 'application/javascript'
                    }
                }

                this.nodes[0].children.push(configNode)
            }
       }  catch(err) {
            this.$debugLog(err)
            this.$bvModal.msgBoxOk("Failed to fetch component settings.")
        }

        document.onkeyup = function(e) {
            if (e.ctrlKey && e.code == 'KeyS') {
                this.save()
            }
        }.bind(this);
    }
}
</script>